/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */


import Page from '../screens/page';
import homePhotoService from '../screens/photoservice/homePhotoService';
import albumPhotos from '../screens/photoservice/albumPhotos';
import addressform from '../screens/addressform';
import checkout from '../screens/checkout';
import Download from '../screens/download';
import SuccesPage from '../screens/succes';
import Contact from '../screens/contact';
import Login from '../screens/auth/login';

const photoServiceRoutes = [
  {
    path: '/album/:album_id',
    component: albumPhotos,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/checkout',
    component: checkout,
    isPrivate: false,
  },
  {
    path: '/succes/type/:type/',
    component: SuccesPage,
    isPrivate: true,
    exact: true,
  },
  {
    path: '/addressform',
    component: addressform,
    isPrivate: false,
  },
  {
    path: '/login',
    component: Login,
    isPrivate: false,
  },
  {
    path: '/download/:hash',
    component: Download,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/:page',
    component: Page,
    isPrivate: false,
  },
  {
    path: '/contact',
    component: Contact,
    isPrivate: false,
    exact: true,
  },
  {
    path: '/',
    component: homePhotoService,
    isPrivate: false,
    exact: true,
  },
];

export default photoServiceRoutes;
